import { actions, reducer } from './global.slice';
import * as selector from './global.selector';

export default { actions, reducer, selector };
